import _regeneratorRuntime from "/app/node_modules/babel-runtime/regenerator";
import _asyncToGenerator from "/app/node_modules/babel-runtime/helpers/asyncToGenerator";
//
//
//
//

export default {
    fetch: function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
            var store = _ref.store,
                app = _ref.app,
                params = _ref.params,
                redirect = _ref.redirect;
            var value;
            return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            value = Number(params.id);

                            if (!(params.idSeller == undefined)) {
                                _context.next = 3;
                                break;
                            }

                            return _context.abrupt("return", redirect("/bosses/channel/" + value));

                        case 3:
                        case "end":
                            return _context.stop();
                    }
                }
            }, _callee, this);
        }));

        function fetch(_x) {
            return _ref2.apply(this, arguments);
        }

        return fetch;
    }()
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bosses/channel/_id/seller/index.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/bosses/channel/_id/seller/index.vue
// module chunks = 30